
    <div class="alert alert-danger" *ngIf="errors && errors.errors">
        <strong>{{ errors.message }}</strong><br>
        <ul>
          <li *ngFor="let item of errors.errors | keyvalue ">{{ item.value[0] }}</li>
        </ul>
    </div>
  